import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
@Component({
  selector: 'app-param-compte',
  templateUrl: './param-compte.component.html',
  styleUrls: ['./param-compte.component.scss'],
})
export class ParamCompteComponent implements OnInit {
  successLoadData = false;
  btn = { text: 'Ajouter', icon: 'add' };

  user = {
    username: '',
    email: '',
    password: '',
    confirmpassword: '',
    tiers: '',
    menu: '',
  };
  initUser;
  Confirmer;
  exist: boolean = true;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Email',
        ' Lg_Code': '',
        TableRD_Des: 'E-mail',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'UserName',
        Lg_Code: '',
        TableRD_Des: "Nom d'utilisateur",
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Menu_Nom',
        Lg_Code: '',
        TableRD_Des: 'Menu',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'Menu_Code',
        textSelect: 'Menu_Code',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Perso_Matricule',
        Lg_Code: '',
        TableRD_Des: 'Collaborateur',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'Perso_Matricule',
        textSelect: 'NomPrenom',
      },
    ],
  };
  listBtnCompte: Array<any> = [
    {
      name: 'modifier',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'ajouter',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifierMotPasse',
      class: 'colorBlue',
      text: 'Modifier mot de passe',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Désactiver',
      disabled: false,
      icon: 'lock',
    },
  ];
  @ViewChild(AvtListesComponent, { static: false })
  listeCompteComponen: AvtListesComponent;
  listeCollaborateur;
  listeCollaborateurIsLoadet: boolean = false;
  listeMenu = [];
  listeMenuIsLoadet: boolean = false;
  listeUsers = [];
  listeUsersIsLoadet: boolean = false;
  confirmpassword: string;
  password: string;
  @ViewChild('frmCompte', { static: false }) frmCompte;
  showMotPasse: boolean = true;
  show: boolean = true;
  constructor(public generalService: GeneralService) {}

  ngOnInit() {
    this.getCollaborateur();
    this.getListeMenu();
    this.getListeUsers();
  }
  ajouter(f) {
    if (f.form.valid) {
      if (this.user.confirmpassword == this.user.password) {
        this.exist = false;
        var user = {
          Email: this.user.email,
          Menu_Nom: this.user.menu,
          Perso_Matricule: this.user.tiers,
          UserName: this.user.username,
          confirmpassword: this.user.confirmpassword,
          password: this.user.password,
        };
        if (this.btn.text == 'Ajouter')
          this.generalService.enregisterCompte(this.user).subscribe(
            (data) => {
              this.modifier(user);
              // this.disableBtnAjouter = false;
              // this.generalService.dialogSuccess("Enregistré",true);
              // this.getListeUsers();
            },
            (err) => {
              this.exist = true;
              this.generalService.dialogSuccess('Non enregistré', false);
            }
          );
        else if (this.btn.text == 'Enregistré compte') {
          this.modifier(user);
        } else {
          this.modifierMosPasse(user);
        }
      } else
        this.generalService.dialogSuccess(
          'Les mots de passe tapés ne sont pas identiques',
          false
        );
    }
  }
  getCollaborateur() {
    this.generalService
      .rechercheTable(this.generalService.urlSelectPerso)
      .subscribe((data) => {
        this.listeCollaborateur = this.generalService.sort(
          data.filter((c) => {
            return c.Perso_TypePerso != '2' && c.Perso_TypePerso != '10';
          }),
          'NomPrenom'
        );
        this.listeCollaborateurIsLoadet = true;
        this.columns.TableRD[3].dataSelect = this.listeCollaborateur;
        if (this.listeUsersIsLoadet && this.listeMenuIsLoadet)
          this.setListeUsers();
      });
  }
  getListeMenu() {
    this.generalService
      .rechercheTable(this.generalService.urlListeMenu)
      .subscribe((menus) => {
        this.listeMenu = this.generalService.sort(menus, 'Menu_Code');
        this.listeMenuIsLoadet = true;
        this.columns.TableRD[2].dataSelect = menus;
        if (this.listeCollaborateurIsLoadet && this.listeUsersIsLoadet)
          this.setListeUsers();
      });
  }
  getListeUsers() {
    this.generalService
      .rechercheTable(this.generalService.urlListeUtilisateur)
      .subscribe((menus) => {
        this.listeUsers = menus;
        this.listeUsersIsLoadet = true;
        if (this.listeCollaborateurIsLoadet && this.listeMenuIsLoadet)
          this.setListeUsers();
        this.exist = true;
        if (this.generalService.dialog) this.generalService.dialog.closeAll();
      });
  }
  setListeUsers() {
    this.listeCompteComponen.setDataSource(this.listeUsers);
  }
  modifier(selectedUser) {
    this.listBtnCompte[0].disabled = true;
    this.generalService
      .rechercheTable(
        this.generalService.urlUser + '&val=' + selectedUser.UserName
      )
      .subscribe((data) => {
        data.Users[0].User_mail = selectedUser.Email;
        data.Users[0].Menu_Nom = selectedUser.Menu_Nom;
        data.Users[0].Perso_Matricule = selectedUser.Perso_Matricule;
        // ne pas supprimer
        data.Users[0].User_Id = selectedUser.UserName;
        this.generalService.enregisterTable(data).subscribe(
          (data) => {
            this.listBtnCompte[0].disabled = false;
            this.generalService.dialogSuccess('Enregistré', true);
            this.getListeUsers();
          },
          (err) => {
            this.generalService.dialogSuccess('Non enregistré', false);

            this.listBtnCompte[0].disabled = false;
          }
        );
      });
  }
  modifierMosPasse(selectedUser) {
    var userr = {
      userName: selectedUser.UserName,
      password: selectedUser.password,
      confirmPassword: selectedUser.confirmpassword,
    };
    this.generalService.modifierMosPass(userr).subscribe(
      (data) => {
        this.exist = true;
        this.generalService.dialogSuccess('Enregistré', true);
        this.listBtnCompte[0].disabled = false;
      },
      (err) => {
        this.generalService.dialogSuccess('Non enregistré', false);
        this.exist = true;
        this.listBtnCompte[0].disabled = false;
      }
    );
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'modifier': {
        this.openFrmModifier(event.row);
        break;
      }
      case 'supprimer': {
        this.supprimerContrat(event.row);
        break;
      }
      case 'ajouter': {
        this.openFrmAjouter();
        break;
      }
      case 'modifierMotPasse': {
        this.openFrmModifierMotPasse(event.row);
        break;
      }
    }
  }
  close() {
    this.generalService.dialog.closeAll();
  }
  openFrmAjouter() {
    this.user = {
      username: '',
      email: '',
      password: '',
      confirmpassword: '',
      tiers: '',
      menu: '',
    };
    this.show = true;
    this.showMotPasse = true;
    // modifier avec prudence =>faire une recherche avec 'Ajouter'
    this.btn.text = 'Ajouter';
    this.btn.icon = 'add';
    this.generalService.dialog.open(this.frmCompte);
  }
  openFrmModifierMotPasse(row) {
    this.show = false;
    this.showMotPasse = true;
    // modifier avec prudence =>faire une recherche avec 'Enregistré mot de passe'
    this.btn.text = 'Enregistré mot de passe';
    this.btn.icon = 'save';
    this.user.username = row.UserName;
    this.user.password = '';
    this.user.confirmpassword = '';
    this.generalService.dialog.open(this.frmCompte);
  }
  openFrmModifier(row) {
    this.show = true;
    this.showMotPasse = false;
    // modifier avec prudence =>faire une recherche avec 'Enregistré compte'
    this.btn.text = 'Enregistré compte';
    this.btn.icon = 'save';
    this.user.username = row.UserName;
    this.user.email = row.User_mail;
    this.user.menu = row.Menu_Nom;
    this.user.tiers = row.Perso_Matricule;
    this.generalService.dialog.open(this.frmCompte);
  }
  supprimerContrat(row) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        var deleteFn = this.generalService.supprimerSanMsgConfirm(
          row.User_Id,
          'users'
        );
        if (deleteFn != null) {
          this.exist = false;
          this.listBtnCompte[1].disabled = true;
          deleteFn.subscribe(
            (data) => {
              this.getListeUsers();
              this.generalService.dialogSuccess('Elément supprimer', true);
              this.exist = true;
              this.listBtnCompte[1].disabled = false;
            },
            (error) => {
              this.generalService.dialogSuccess('Elément non supprimé', false);
              this.exist = true;
              this.listBtnCompte[1].disabled = false;
            }
          );
        }
      }
      if (result == 'annuler') {
      }
    });
  }
}
